import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { t } from '@lib/translation';
import { SnFormFieldConfig } from 'libs/form/src/lib/types/form-field-config.type';

@Component({
  selector: 'sn-custom-date-range-dialog',
  templateUrl: './custom-date-range-dialog.component.html',
  styleUrls: ['./custom-date-range-dialog.component.scss'],
})
export class CustomDateRangeDialogComponent implements OnInit {
  public form = new UntypedFormGroup({});
  public formModel: any = {};
  public dateFields: SnFormFieldConfig[] = [
    {
      fieldGroupClassName: 'date-range-form-row',
      fieldGroup: [
        {
          key: 'startDate',
          type: 'datetimepicker',
          className: 'date-range-form-column',
          templateOptions: {
            label: t('common.startTime'),
            appearance: 'fill',
            required: true,
            maxDate: () => (this.formModel.endDate ? this.formModel.endDate : null),
            change: (field, value) => {
              if (!value) {
                return;
              }
              this.validateDates();
            },
          },
          validators: {
            validation: [Validators.required],
          },
        },
        {
          key: 'endDate',
          type: 'datetimepicker',
          className: 'date-range-form-column',
          templateOptions: {
            label: t('common.endTime'),
            appearance: 'fill',
            required: true,
            minDate: () => (this.formModel.startDate ? this.formModel.startDate : null),
            change: (field, value) => {
              if (!value) {
                return;
              }
              this.validateDates();
            },
          },
          validators: {
            validation: [Validators.required],
          },
        },
      ],
    },
  ];

  public isValid: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _matDialogRef: MatDialogRef<CustomDateRangeDialogComponent>,
  ) {}

  public ngOnInit(): void {
    if (Object.keys(this.data).length) {
      this.formModel.startDate = this.data.startDate;
      this.formModel.endDate = this.data.endDate;
    }
  }

  public validateDates(): void {
    if (!this.formModel.startDate || !this.formModel.endDate) {
      this.isValid = false;
      return;
    }

    const startDate = new Date(this.formModel.startDate);
    const endDate = new Date(this.formModel.endDate);

    this.isValid = startDate < endDate && this.form.valid;
  }

  public onDateChange(): void {
    if (!this.isValid) {
      return;
    }

    this.formModel.startDate = new Date(this.formModel.startDate);
    this.formModel.endDate = new Date(this.formModel.endDate);
    this._matDialogRef.close(this.formModel);
  }

  public close(): void {
    this._matDialogRef.close();
  }
}
